import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import { Viewport } from '../vendor/react-measure';
import AnimateScroll from './AnimateScroll';
import Body from './Body';
import Header from './Header';
import HeaderRow from './HeaderRow';
import NavigationArrow from './NavigationArrow';
import ScrollShadow from './ScrollShadow';
import TableContainer from './TableContainer';
var BUTTON_WIDTH = 28;

var TableBase = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(TableBase, _PureComponent);

  function TableBase() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "setHeaderRef", function (node) {
      _this.tableHeader = node;
    });

    _defineProperty(_assertThisInitialized(_this), "clearTimers", function () {
      clearTimeout(_this.scrollTimeout);
      clearInterval(_this.scrollInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "getMouseTouchHandlers", function (_ref) {
      var animateScroll = _ref.animateScroll,
          getClosestColumnPosition = _ref.getClosestColumnPosition;
      return function (direction) {
        var onPressDown = function onPressDown() {
          _this.clearTimers();

          _this.scrollTimeout = setTimeout(function () {
            animateScroll.moveScrollX(100 * direction);
            _this.scrollInterval = setInterval(function () {
              animateScroll.moveScrollX(100 * direction);
            }, 60);
          }, 120);
        };

        var onPressUp = function onPressUp() {
          _this.clearTimers();

          animateScroll.setScrollX(getClosestColumnPosition(direction));
        };

        return {
          onMouseDown: onPressDown,
          onMouseUp: onPressUp,
          onMouseLeave: _this.clearTimers,
          onTouchStart: onPressDown,
          onTouchEnd: onPressUp,
          onTouchCancel: _this.clearTimers
        };
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleBodyScroll", function (event) {
      _this.tableHeader.scrollLeft = event.target.scrollLeft;
    });

    return _this;
  }

  var _proto = TableBase.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        body = _this$props.body,
        caption = _this$props.caption,
        columnWidths = _this$props.columnWidths,
        header = _this$props.header,
        headerColor = _this$props.headerColor,
        headerHeight = _this$props.headerHeight,
        minHeight = _this$props.minHeight,
        offsets = _this$props.offsets,
        rowWidth = _this$props.rowWidth,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["body", "caption", "columnWidths", "header", "headerColor", "headerHeight", "minHeight", "offsets", "rowWidth"]);

    return /*#__PURE__*/React.createElement(AnimateScroll, null, function (animateScroll) {
      return /*#__PURE__*/React.createElement(Viewport, null, function (viewport) {
        var canScroll = rowWidth > viewport.width;
        var progress = canScroll ? viewport.scrollX / (rowWidth - viewport.width) : null;

        var getClosestColumnPosition = function getClosestColumnPosition(direction) {
          var currentScrollPosition = direction === 1 ? viewport.scrollX + viewport.width : viewport.scrollX;
          var newScrollPosition = 0;
          var totalWidth = 0;
          columnWidths.some(function (columnWidth) {
            totalWidth += columnWidth;

            if (totalWidth > currentScrollPosition) {
              newScrollPosition = direction === 1 ? totalWidth : totalWidth - columnWidth;
              return true;
            }

            return false;
          });
          return direction === 1 ? newScrollPosition - viewport.width + offsets.right + BUTTON_WIDTH : newScrollPosition - offsets.left - BUTTON_WIDTH;
        };

        var mouseTouchHandlers = _this2.getMouseTouchHandlers({
          animateScroll: animateScroll,
          getClosestColumnPosition: getClosestColumnPosition
        });

        return /*#__PURE__*/React.createElement(TableContainer, _extends({
          minHeight: minHeight,
          "aria-label": caption
        }, restProps), canScroll && /*#__PURE__*/React.createElement(ScrollShadow, {
          position: "left",
          offset: offsets.left,
          progress: progress
        }), /*#__PURE__*/React.createElement(Header, {
          innerRef: _this2.setHeaderRef,
          backgroundColor: headerColor
        }, /*#__PURE__*/React.createElement(HeaderRow, {
          style: {
            minWidth: rowWidth
          }
        }, /*#__PURE__*/React.createElement(NavigationArrow, {
          headerHeight: headerHeight,
          offsets: offsets,
          progress: progress,
          mouseTouchHandlers: mouseTouchHandlers,
          direction: -1
        }), header, /*#__PURE__*/React.createElement(NavigationArrow, {
          headerHeight: headerHeight,
          offsets: offsets,
          progress: progress,
          mouseTouchHandlers: mouseTouchHandlers,
          direction: 1
        }))), /*#__PURE__*/React.createElement(Body, {
          innerRef: viewport.ref(animateScroll.ref),
          onScroll: _this2.handleBodyScroll
        }, body), canScroll && /*#__PURE__*/React.createElement(ScrollShadow, {
          position: "right",
          offset: offsets.right,
          progress: progress
        }));
      });
    });
  };

  return TableBase;
}(PureComponent);

export default TableBase;